// extracted by mini-css-extract-plugin
export default {"bold":"RequestResellerCodeModal_bold__gToiY"};